import React, { useEffect, useRef } from 'react';
import SEO from '../components/SEO';

const AboutUs = () => {
  const observerRef = useRef();

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          } else {
            entry.target.classList.remove('animate-in');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    const elements = document.querySelectorAll('.animate-on-scroll');
    elements.forEach((el) => observerRef.current.observe(el));

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return (
    <>
      <SEO 
        title="회사소개 - 한국국민금거래소"
        description="대한민국 최고의 금거래 전문기업 한국국민금거래소. 순금, 18K, 14K, 백금, 은, 다이아몬드, 중고명품시계 최고가 매입"
        keywords="한국국민금거래소, 금거래전문기업, 금매입, 다이아몬드매입, 명품시계매입, 금거래소소개"
        url="https://koreakookmingold.com/about"
      />
      <div className="about-us">
      <section className="section section--about">
        <div className="container">
          <div className="section__header animate-on-scroll">
            <h2 className="section__title">
              대한민국 최고의<br />
              <span className="section__title--highlight">금거래 전문기업</span>
            </h2>
          </div>
          
          <div className="service-list">
            <div className="service-list__item animate-on-scroll">
              <div className="service-list__icon">
                <img src="/images/icon-1.webp" alt="금매입" className="service-list__image" />
              </div>
              <h3 className="service-list__title">금매입</h3>
              <p className="service-list__description">순금, 18K, 14K, 백금, 은 치금 등<br />최고가 시세로 매입</p>
            </div>
            <div className="service-list__item animate-on-scroll">
              <div className="service-list__icon">
                <img src="/images/icon-2.webp" alt="다이아몬드" className="service-list__image" />
              </div>
              <h3 className="service-list__title">다이아몬드 매입</h3>
              <p className="service-list__description">우신, 현대, GIA 등 감정서가 없는<br />다이아도 무료 감정 후 고가 매입</p>
            </div>
            <div className="service-list__item animate-on-scroll">
              <div className="service-list__icon">
                <img src="/images/icon-3.webp" alt="명품시계" className="service-list__image" />
              </div>
              <h3 className="service-list__title">중고명품시계 매입</h3>
              <p className="service-list__description">중고명품시계<br />고가 매입</p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-details">
        <div className="container">
          <div className="detail-item animate-on-scroll">
            <div className="detail-item__content">
              <span className="detail-item__number">01</span>
              <h3 className="detail-item__title">금매입</h3>
              <p className="detail-item__desc">
                대한민국 금거래 중심!<br />
                한국국민금거래소에서 골드바를 만나보세요.<br />
                순금, 18K, 14K, 백금, 은, 치금 등 최고가 시세로 매입도 가능합니다.
              </p>
            </div>
            <div className="detail-item__image">
              <img src="/images/about/about-1.webp" alt="금매입" />
            </div>
          </div>
          
          <div className="detail-item detail-item--reverse animate-on-scroll">
            <div className="detail-item__content">
              <span className="detail-item__number">02</span>
              <h3 className="detail-item__title">다이아몬드 매입</h3>
              <p className="detail-item__desc">
                대한민국 금거래 중심!<br />
                한국국민금거래소에서 우신, 현대, GIA 등 감정서가 없는 다이아도 무료 감정 후 고가 매입도 가능합니다.
              </p>
            </div>
            <div className="detail-item__image">
              <img src="/images/about/about-2.webp" alt="다이아몬드 매입" />
            </div>
          </div>
          
          <div className="detail-item animate-on-scroll">
            <div className="detail-item__content">
              <span className="detail-item__number">03</span>
              <h3 className="detail-item__title">중고명품시계 매입</h3>
              <p className="detail-item__desc">
                대한민국 금거래 중심!<br />
                한국국민금거래소에서 중고명품시계 고가 매입도 가능합니다.
              </p>
            </div>
            <div className="detail-item__image">
              <img src="/images/about/about-3.webp" alt="중고명품시계 매입" />
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
  );
};

export default AboutUs;